<template>
  <div class="cart">
    <div class="main">
      <div class="list address-list" v-if="addressList && addressList.length>0">
        <ul>
          <li v-for="item in addressList" :class="!item.isVaild && isForm? 'vaild' : ''" >
            <div class="delete-btn">删除</div>
            <div class="swiper-container swiper-delete swiper-container-horizontal">
              <div class="swiper-wrapper" >
                <div class="content swiper-slide" @click="handleClickChooseAddress(item)">
                  <div class="content-box" style="width: 100%">
                    <div v-if="!item.isLimitFloor" class="item ellipses-two" :class="!item.isVaild && isForm? 'opa-5' : ''">
                      <span v-if="item.detail && item.poi_address">{{item.poi_address}}{{item.detail}}</span>
                      <span v-else-if="item.build_name">【{{item.build_name}}-{{item.floor_name}}-{{item.room_name}}】</span>
                      <span v-else>{{item.poi_address}}</span>
                    </div>
                    <div v-else class="item ellipses-two" :class="!item.isVaild && isForm ? 'opa-5' : ''">
                      <span v-if="item.build_name">【{{item.build_name}}-{{item.floor_name}}-{{item.room_name}}】</span>
                      <span v-else>{{item.poi_address}} {{item.detail}}</span>
                    </div>
                    <span class="address" :class="!item.isVaild && isForm ? 'opa-5' : ''">{{item.addressee}} {{item.mp}}</span>

                  </div>
                  <a v-if="item.isVaild || !isForm" @click.stop="editAddress(item)" class="icon icon-edit"></a>
                  <a v-if="!item.isVaild && isForm" @click.stop="editAddress(item)" class="iconEdit">
                    <img src="../assets/images/edit.png" style="width: .38rem;height: .38rem;">
                    <div style="line-height: .38rem;margin-left: 0.05rem;">完善信息</div>
                  </a>

                  <div :class="{choose: item.id === chooseAddress.id && (item.isVaild || !isForm)}"></div>
                </div>
                <div class="delete-btn2 swiper-slide" @click="handleClickDeleteAddress(item)"></div>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="no-info" v-else>
        <div class="no-goods">
          <img src="../assets/images/empty-01.png" />
          <p>这里没有收货地址</p>
        </div>
      </div>
    </div>
    <footer class="block fixed">
      <a @click="toAddAddress" class="btn btn-main btn-lg btn-block">新增收货地址</a>
    </footer>
  </div>
</template>

<script>
  import {actions} from '../store/actions'
  // import { MessageBox } from 'mint-ui'

  export default {
    data () {
      return {
        addressList: [],
        chooseAddress: {},
        isFloor: false, //是否是楼栋模式
        addressVaild: [],
        addressInVaild: [],
        isForm: false, //从订单过来
      }
    },
    computed: {
      wxUid () {
        return this.$store.state.wxUid
      },
      schoolInfo () {
        return this.$store.state.schoolInfo
      }
    },
    mounted () {
      var _this = this;
      // document.title = '我的收货地址';

      if(window.localStorage.getItem('chooseAddress')) {
        _this.chooseAddress = JSON.parse(window.localStorage.getItem('chooseAddress'))
      }
      window.localStorage.removeItem('addressInfo');
      this.isForm = window.localStorage.getItem('fromPage') == 'OrderSettle'
      _this.getAddressList();
      window.localStorage.setItem('orderPreviewType', 2);
    },
    methods: {
      // 获取地址列表
      getAddressList: function () {
        var _this = this
        var params = {
          page: 1,
          pageSize: 50,
          school_id: this.$store.state.schoolInfo.schoolId,
        }
        actions.postAddressList(_this, params, function (data) {
          let list = []
          if(data && data.length > 0){
            // console.log(_this.isForm);
            if(_this.isForm){
              _this.addressList = []
              _this.addressInVaild =[]
              _this.addressVaild =[]
              _this.isFloor = data[0].isLimitFloor
              data.forEach(item=>{
                if(_this.isFloor){
                  if(item.build_id && item.floor_id && item.room_id){
                    item.isVaild = true
                    _this.addressVaild.push(item)
                  }else{
                    item.isVaild = false
                    item.is_default = 0
                    _this.addressInVaild.push(item)
                  }
                }else{
                  if(item.poi_address){
                    item.isVaild = true
                    _this.addressVaild.push(item)
                  }else{
                    item.isVaild = false
                    item.is_default = 0
                    _this.addressInVaild.push(item)
                  }
                }
              })
              list = _this.addressVaild.concat(_this.addressInVaild)
            }else{
              list = data
            }
          }
          _this.addressList = list
          _this.$nextTick(function () {
            var mySwiper = new Swiper('.swiper-container', {
              slidesPerView: 'auto',
              observer:true, // 修改swiper自己或子元素时，自动初始化swiper
              observeParents:true // 修改swiper的父元素时，自动初始化swiper
            });
          })

        })
      },
      // 编辑地址
      editAddress: function (item) {
        var _this = this;
        window.localStorage.setItem('address-id', item.id)
        _this.$router.push({name: 'EditAddress'})
      },
      // 删除地址
      handleClickDeleteAddress: function (e) {
        var _this = this
        _this.$messagebox.confirm('确定要删除此地址吗?','').then(action => {
          var params = {
            id: e.id
          }
          actions.postDeleteAddress(_this, params, function () {
            // window.location.reload();
            _this.getAddressList()
            if(_this.addressList.length == 0){
              window.localStorage.removeItem('chooseAddress')
            }
          })
        }).catch(() => {

        })
      },
      // 选择地址
      handleClickChooseAddress: function (e) {
        var _this = this
        if(window.localStorage.getItem('fromPage') == 'UserCenter') { //代表从我的地址入口进入，无法跳转
        } else {
          window.localStorage.setItem('chooseAddress',JSON.stringify(e))
          var params = {
            id: e.id
          }
          actions.postSetDefaultAddress(_this, params, function () {
            window.localStorage.setItem('orderPreviewType', 2)
            _this.$router.go(-1);
          },function (data) {
            _this.$messagebox.alert(data.body.message,'')
          })
        }
      },
      // 新增地址
      toAddAddress: function () {
        var _this = this
        window.localStorage.removeItem('addAddressInfo');
        _this.$router.push({name: 'AddAddress'})
      }
    }
  }
</script>

<style scoped>
  .item{
    font-size: .3rem;
    color: #666;
    font-weight: bold;
    margin-bottom: .15rem;
  }
  .ellipses-two{
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }
  .address{
    font-size: .24rem;
    color: #333;
    margin-bottom: .1rem;
    font-weight: bolder;
  }
  /*.vaild{*/
  /*  border-bottom:  1px solid rgba(0,0,0,0.06) !important;*/
  /*}*/
  ul > .vaild:not(.vaild ~.vaild) {
    margin-top: .10rem;
  }
  .iconEdit{
    right: .3rem;
    position: absolute;
    top: 65%;
    margin-top: -.5rem;
    color: #FF7C35;
    font-size: .24rem;
    padding: .06rem;
    display: flex;
  }
  .opa-5{
    opacity: 0.5;
  }
</style>



// WEBPACK FOOTER //
// AddressList.vue?b904f762